import { MyInvoices } from '@src/pages/ticketRestaurant/index';

const GiftMyInvoices = () => {
  return <MyInvoices isMarket={true} />;
};

export default GiftMyInvoices;
